/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 * 
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
  from '@thd-olt-component-react/fusion-utils';

  

  import {
    RulesMiddleware as RulesMiddleware_MiddlewareSlot
  } from '@thd-olt-component-middleware/pip';



  import { withMagicApronTNT } from '@thd-olt-component-middleware/pip';






import { BotPrompt as BotPromptSSR } from '@thd-olt-component-react/magic-apron?clientSideRemove';

import { ProductOverviewAccordionBody as ProductOverviewAccordionBodySSR } from '@thd-olt-component-react/product-overview?clientSideRemove';

import { SpecificationsWithKPFAccordionBody as SpecificationsWithKPFAccordionBodySSR } from '@thd-olt-component-react/specifications?clientSideRemove';

import { QuestionsAndAnswersAccordionBody as QuestionsAndAnswersAccordionBodySSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionBody as RatingsAndReviewsAccordionBodySSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';

import { RoomVoInspire as RoomVoInspireSSR } from '@thd-olt-component-react/augmented-reality?clientSideRemove';


const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
}

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  
    

    
    
    
      
      
        
        
          const SlotG4Placeholder0 = null;
        
        
        const SlotG4Index0Client = () => {
          return import(
              '@thd-olt-component-react/magic-apron');
        }

        
        export const SlotG4Index0Load = withDynamicImport({
          server: () => {
            return BotPromptSSR;
          },
          client: SlotG4Index0Client,
          placeholder: SlotG4Placeholder0 || getPlaceholder({ skip: true }),
          name: 'BotPrompt',
        });

        
      
      

      
        let RulesMiddleware_MiddlewareSlot_SlotG4 = RulesMiddleware_MiddlewareSlot;
        
          
            RulesMiddleware_MiddlewareSlot_SlotG4 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_SlotG4, {"render":{"name":"fs-prop:magic-apron-qa-bot-render-placement","value":"above-accordion"}})
          
        
      


      
      
      lazySlots.LazySlotG4 = withLayout(
        
        [
        
          SlotG4Index0Load,
        
        ],
        
        
          RulesMiddleware_MiddlewareSlot_SlotG4
        ,
        
        [
        
        {
          waitForComponent: SlotG4Index0Client,
          placeholder: SlotG4Placeholder0 || getPlaceholder({ skip: true })
        },
        
        ]
      );
      


    



    
      
  

  
    

    
      
        
        
          
          
            const SlotG5Placeholder0K0 = null;
          

          
          const SlotG5Index0ClientK0 = () => {
            return import(
              '@thd-olt-component-react/product-overview');
          };
          
          export const SlotG5Index0LoadK0 = withDynamicImport({
            server: () => {
              return ProductOverviewAccordionBodySSR;
            },
            client: SlotG5Index0ClientK0,
            placeholder: SlotG5Placeholder0K0 || getPlaceholder({ skip: true }),
            name: 'ProductOverviewAccordionBody',
          });
          

          



          lazySlots.LazySlotG5KBody1 = withLayout(
            SlotG5Index0LoadK0,
            
              null
            ,
            {
              waitForComponent: SlotG5Index0ClientK0,
              placeholder: SlotG5Placeholder0K0 || getPlaceholder({ skip: true })
            }
          );     
        
        
      
      
        
        
          
          
            const SlotG5Placeholder1K0 = null;
          

          
          const SlotG5Index1ClientK0 = () => {
            return import(
              '@thd-olt-component-react/specifications');
          };
          
          export const SlotG5Index1LoadK0 = withDynamicImport({
            server: () => {
              return SpecificationsWithKPFAccordionBodySSR;
            },
            client: SlotG5Index1ClientK0,
            placeholder: SlotG5Placeholder1K0 || getPlaceholder({ skip: true }),
            name: 'SpecificationsWithKPFAccordionBody',
          });
          

          



          lazySlots.LazySlotG5KBody2 = withLayout(
            SlotG5Index1LoadK0,
            
              null
            ,
            {
              waitForComponent: SlotG5Index1ClientK0,
              placeholder: SlotG5Placeholder1K0 || getPlaceholder({ skip: true })
            }
          );     
        
        
      
      
        
        
          
          
            const SlotG5Placeholder2K0 = null;
          

          
          const SlotG5Index2ClientK0 = () => {
            return import(
              '@thd-olt-component-react/questions-and-answers');
          };
          
          export const SlotG5Index2LoadK0 = withDynamicImport({
            server: () => {
              return QuestionsAndAnswersAccordionBodySSR;
            },
            client: SlotG5Index2ClientK0,
            placeholder: SlotG5Placeholder2K0 || getPlaceholder({ skip: true }),
            name: 'QuestionsAndAnswersAccordionBody',
          });
          

          



          lazySlots.LazySlotG5KBody3 = withLayout(
            SlotG5Index2LoadK0,
            
              null
            ,
            {
              waitForComponent: SlotG5Index2ClientK0,
              placeholder: SlotG5Placeholder2K0 || getPlaceholder({ skip: true })
            }
          );     
        
        
      
      
        
        
          
          
            const SlotG5Placeholder3K0 = null;
          

          
          const SlotG5Index3ClientK0 = () => {
            return import(
              '@thd-olt-component-react/ratings-and-reviews');
          };
          
          export const SlotG5Index3LoadK0 = withDynamicImport({
            server: () => {
              return RatingsAndReviewsAccordionBodySSR;
            },
            client: SlotG5Index3ClientK0,
            placeholder: SlotG5Placeholder3K0 || getPlaceholder({ skip: true }),
            name: 'RatingsAndReviewsAccordionBody',
          });
          

          



          lazySlots.LazySlotG5KBody4 = withLayout(
            SlotG5Index3LoadK0,
            
              null
            ,
            {
              waitForComponent: SlotG5Index3ClientK0,
              placeholder: SlotG5Placeholder3K0 || getPlaceholder({ skip: true })
            }
          );     
        
        
      
      
    
    
    
    



    
    
      
      
        
          import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleSlotG5Index0K0Header }
            from '@thd-olt-component-react/product-overview';
          
      
        
          import { SpecificationsAccordionTitle as SpecificationsAccordionTitleSlotG5Index1K0Header }
            from '@thd-olt-component-react/specifications';
          
      
        
          import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleSlotG5Index2K0Header }
            from '@thd-olt-component-react/questions-and-answers';
          
      
        
          import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleSlotG5Index3K0Header }
            from '@thd-olt-component-react/ratings-and-reviews';
          
        

      

      
        
            
        
      
        
            
        
      
        
            
        
      
        
            
        
      

      const LazySlotG5Accordion = withLayoutAccordion([
        [
        
          [
          
            withLayout(
              ProductOverviewAccordionTitleSlotG5Index0K0Header,
              
            ),
          
          ],
        
          [
          
            withLayout(
              SpecificationsAccordionTitleSlotG5Index1K0Header,
              
            ),
          
          ],
        
          [
          
            withLayout(
              QuestionsAndAnswersAccordionTitleSlotG5Index2K0Header,
              
            ),
          
          ],
        
          [
          
            withLayout(
              RatingsAndReviewsAccordionTitleSlotG5Index3K0Header,
              
            ),
          
          ],
        
        ],
        [
        
          [
          
            lazySlots.LazySlotG5KBody1,
          
          ],
        
          [
          
            lazySlots.LazySlotG5KBody2,
          
          ],
        
          [
          
            lazySlots.LazySlotG5KBody3,
          
          ],
        
          [
          
            lazySlots.LazySlotG5KBody4,
          
          ],
        
        ]
      ],
      
        null
      )
      
  

  
    

    
    
    
      
      
        
        
          const SlotG6Placeholder0 = null;
        
        
        const SlotG6Index0Client = () => {
          return import(
              '@thd-olt-component-react/magic-apron');
        }

        
        export const SlotG6Index0Load = withDynamicImport({
          server: () => {
            return BotPromptSSR;
          },
          client: SlotG6Index0Client,
          placeholder: SlotG6Placeholder0 || getPlaceholder({ skip: true }),
          name: 'BotPrompt',
        });

        
      
      

      
        let RulesMiddleware_MiddlewareSlot_SlotG6 = RulesMiddleware_MiddlewareSlot;
        
          
            RulesMiddleware_MiddlewareSlot_SlotG6 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_SlotG6, {"render":{"name":"fs-prop:magic-apron-qa-bot-render-placement","value":"default","default":true}})
          
        
      


      
      
      lazySlots.LazySlotG6 = withLayout(
        
        [
        
          SlotG6Index0Load,
        
        ],
        
        
          RulesMiddleware_MiddlewareSlot_SlotG6
        ,
        
        [
        
        {
          waitForComponent: SlotG6Index0Client,
          placeholder: SlotG6Placeholder0 || getPlaceholder({ skip: true })
        },
        
        ]
      );
      


    



    
      
  

  

  
    

    
    
    
      
      
        
        
          const SlotG8Placeholder0 = null;
        
        
        const SlotG8Index0Client = () => {
          return import(
              '@thd-olt-component-react/augmented-reality');
        }

        
        export const SlotG8Index0Load = withDynamicImport({
          server: () => {
            return RoomVoInspireSSR;
          },
          client: SlotG8Index0Client,
          placeholder: SlotG8Placeholder0 || getPlaceholder({ skip: true }),
          name: 'RoomVoInspire',
        });

        
      
      

      


      
      
      lazySlots.LazySlotG8 = withLayout(
        
        [
        
          SlotG8Index0Load,
        
        ],
        
        
          null
        ,
        
        [
        
        {
          waitForComponent: SlotG8Index0Client,
          placeholder: SlotG8Placeholder0 || getPlaceholder({ skip: true })
        },
        
        ]
      );
      


    



    
      
  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  

  



// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
    components.forEach((com, index) => {
      // eslint-disable-next-line no-param-reassign
      com.props = hydratedProps[index]
    });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  const ssr = typeof window === 'undefined';
  const decisionIndex = ssr
    ? 0
    : Number(
        (window.__SLOT_DECISIONS__ && window.__SLOT_DECISIONS__[props.slot]) ?? "0"
      );

  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
      if (props.slot === 'SlotG4') {
      
        
          
          return (
            <lazySlots.LazySlotG4
              {...props}
              {...hydratedProps[0]}
              config={props.config}
              fusionSlotName="SlotG4"
              fusionComponentName="@thd-olt-component-react/magic-apron"
              version="7.3.1"
            />
          );
        
        
      }
    
  
    
      if (props.slot === 'SlotG5') {
      
        return (
          <LazySlotG5Accordion
            {...props}
            config={props.config}
            fusionSlotName="SlotG5"
            fusionComponentName="accordion"
            fusionClassName={slot.fusionClassName}
            isDynamic
            // commenting inner query provider since withDynamicImport already wraps AccordionBody with inner query provider
            // queryProvider={{
            //   inherit: 'page',
            //   merge,
            //   queryOptions,
            //   cache key for all accordions must be the same
            //   otherwise a race condition will occur generating duplicate requests
            //   cacheKey: 'page',
            //   defaultVariables: props?.qctx?.defaultVariables?.current || { storeId, zipCode: storeZip }
            // }}
          />
        );
        
      }
    
  
    
      if (props.slot === 'SlotG6') {
      
        
          
          return (
            <lazySlots.LazySlotG6
              {...props}
              {...hydratedProps[0]}
              config={props.config}
              fusionSlotName="SlotG6"
              fusionComponentName="@thd-olt-component-react/magic-apron"
              version="7.3.1"
            />
          );
        
        
      }
    
  
    
  
    
      if (props.slot === 'SlotG8') {
      
        
          
          return (
            <lazySlots.LazySlotG8
              {...props}
              {...hydratedProps[0]}
              config={props.config}
              fusionSlotName="SlotG8"
              fusionComponentName="@thd-olt-component-react/augmented-reality"
              version="7.5.1"
            />
          );
        
        
      }
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  


  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};